var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBybit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 29,
    viewBox: "0 0 89 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bybit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.2435 21.8994V0.17984H67.8269V21.8994H63.2435Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.82596 28.3511H-3.05176e-05V6.63153H9.43083C14.0143 6.63153 16.685 9.01087 16.685 12.7327C16.685 15.1419 14.9698 16.6988 13.7826 17.2172C15.1996 17.827 17.0136 19.1994 17.0136 22.0988C17.0136 26.1546 14.0143 28.3511 9.82596 28.3511ZM9.06805 10.4149H4.58339V15.4177H9.06805C11.0132 15.4177 12.1015 14.4108 12.1015 12.9154C12.1015 11.4217 11.0132 10.4149 9.06805 10.4149ZM9.36438 19.2309H4.58339V24.5694H9.36438C11.4424 24.5694 12.4302 23.3499 12.4302 21.8844C12.4302 20.4206 11.4405 19.2309 9.36438 19.2309Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.9935 19.4436V28.3511H26.4424V19.4436L19.3859 6.63153H24.3644L28.7503 15.3861L33.0697 6.63153H38.0483L30.9935 19.4436Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M51.0426 28.3511H41.2166V6.63153H50.6475C55.2309 6.63153 57.9016 9.01087 57.9016 12.7327C57.9016 15.1419 56.1864 16.6988 54.9992 17.2172C56.4163 17.827 58.2303 19.1994 58.2303 22.0988C58.2303 26.1546 55.2309 28.3511 51.0426 28.3511ZM50.2847 10.4149H45.8V15.4177H50.2847C52.2298 15.4177 53.3182 14.4108 53.3182 12.9154C53.3182 11.4217 52.2298 10.4149 50.2847 10.4149ZM50.581 19.2309H45.8V24.5694H50.581C52.659 24.5694 53.6468 23.3499 53.6468 21.8844C53.6468 20.4206 52.659 19.2309 50.581 19.2309Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M82.5993 10.4149V28.3528H78.0159V10.4149H71.8825V6.63153H88.7327V10.4149H82.5993Z",
    fill: "#808080"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBybit);
export default __webpack_public_path__ + "static/media/bybit.53815c631a9badf2b62d0c51e71b5c98.svg";
export { ForwardRef as ReactComponent };